<template>
  <div>
    <Transition name="filter-menu-slide" :duration="300">
      <div v-show="isOpen" class="overscroll-contain overflow-y-auto size-full inset-0 min-h-[100svh] fixed z-50 overflow-x-hidden">
        <div class="product-filters-overlay inset-0 bg-overlay fixed cursor-pointer" @click="close" />
        <div class="product-filters-menu left-0 max-w-lg bg-surface-raised shadow-lg absolute min-h-[100svh] w-full">
          <section class="bg-gradient-to-t from-grey-50 to-grey-100 h-20 py-2 flex items-center">
            <BaseButton look="ghost" class="size-12 p-0 absolute top-4 right-4 z-30" @click="close">
              <XMarkIcon class="size-6" />
            </BaseButton>
            <div class="px-4 lg:px-8">
              <div class="beta" data-jest="filter-heading">
                Suodata
              </div>
            </div>
          </section>
          <section class="bg-surface-raised">
            <FilterList />
            <div class="mt-12 container sticky bottom-0 z-10 border-t bg-gradient-to-b from-grey-100/80 to-grey-100">
              <AisStats v-slot="{ nbHits }">
                <BaseButton data-jest="show-products" class="flex-none w-full my-4" @click="close">
                  <span>Näytä {{ nbHits }} {{ nbHits === 1 ? 'tuote' : 'tuotetta' }}</span>
                </BaseButton>
              </AisStats>
              <div class="text-center pb-4">
                <AisClearRefinements v-slot="{ canRefine, refine }">
                  <BaseButton
                    look="ghost"
                    :disabled="!canRefine"
                    @click="refine"
                  >
                    Poista valinnat
                  </BaseButton>
                </AisClearRefinements>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline'
import FilterList from '~/components/category/product-filters/FilterList.vue'

defineProps({
  isOpen: {
    type: Boolean,
    required: true
  }
})
const emit = defineEmits(['close'])
const close = () => {
  emit('close')
}
</script>

<style lang="scss">
.filter-menu-slide-enter-active, .filter-menu-slide-leave-active {
  .product-filters-menu, .product-filters-overlay {
    @apply transition-all duration-300 ease-in;
  }
}
.filter-menu-slide-enter-from, .filter-menu-slide-leave-to {
  .product-filters-menu {
    @apply transform -translate-x-full opacity-0;
  }
  .product-filters-overlay {
    @apply opacity-0;
  }
}
</style>
